// extracted by mini-css-extract-plugin
var _1 = "SingleStat__amt--lIoP8";
var _2 = "SingleStat__check--y95ok SingleStat__main--NAHOA";
var _3 = "SingleStat__checkAmt--RGGqS SingleStat__amt--lIoP8";
var _4 = "SingleStat__checkIcon--ni_e8 SingleStat__icon--UargA";
var _5 = "SingleStat__comet--HeRZw SingleStat__main--NAHOA";
var _6 = "SingleStat__cometAmt--LEDTY SingleStat__amt--lIoP8";
var _7 = "SingleStat__cometIcon--D2OJv SingleStat__icon--UargA";
var _8 = "SingleStat__disabled--IBwjW";
var _9 = "SingleStat__galaxy--bT8LZ SingleStat__main--NAHOA";
var _a = "SingleStat__galaxyAmt--FNR5A SingleStat__amt--lIoP8";
var _b = "SingleStat__galaxyIcon--i1jng SingleStat__icon--UargA";
var _c = "SingleStat__gray--BT_Qp";
var _d = "SingleStat__icon--UargA";
var _e = "SingleStat__jigsaw--Gk5y3 SingleStat__main--NAHOA";
var _f = "SingleStat__jigsawAmt--V1zxE SingleStat__amt--lIoP8";
var _10 = "SingleStat__jigsawIcon--xiVrB SingleStat__icon--UargA";
var _11 = "SingleStat__main--NAHOA";
var _12 = "SingleStat__moon--QEdX8 SingleStat__main--NAHOA";
var _13 = "SingleStat__moonAmt--TF40g SingleStat__amt--lIoP8";
var _14 = "SingleStat__moonIcon--zuqrK SingleStat__icon--UargA";
var _15 = "SingleStat__office--RxjJh";
var _16 = "SingleStat__planet--gHB05 SingleStat__main--NAHOA";
var _17 = "SingleStat__planetAmt--nOI_8 SingleStat__amt--lIoP8";
var _18 = "SingleStat__planetIcon--ZOloU SingleStat__icon--UargA";
var _19 = "SingleStat__star--kpeQp SingleStat__main--NAHOA";
var _1a = "SingleStat__starAmt--ArNVv SingleStat__amt--lIoP8";
var _1b = "SingleStat__starIcon--iRaKL SingleStat__icon--UargA";
var _1c = "SingleStat__student--hDrzv SingleStat__main--NAHOA";
var _1d = "SingleStat__studentAmt--NjZY8 SingleStat__amt--lIoP8";
var _1e = "SingleStat__studentIcon--fZ61O SingleStat__icon--UargA";
var _1f = "SingleStat__time--qG_gw SingleStat__main--NAHOA";
var _20 = "SingleStat__timeAmt--gena3 SingleStat__amt--lIoP8";
var _21 = "SingleStat__timeIcon--iHAKG SingleStat__icon--UargA";
var _22 = "SingleStat__trophy--Nbwgh SingleStat__main--NAHOA";
var _23 = "SingleStat__trophyAmt--tqsTV SingleStat__amt--lIoP8";
var _24 = "SingleStat__trophyIcon--ZIxKh SingleStat__icon--UargA";
var _25 = "SingleStat__xp--guOvZ SingleStat__main--NAHOA";
var _26 = "SingleStat__xpAmt--zDCT3 SingleStat__amt--lIoP8";
var _27 = "SingleStat__xpIcon--o2u6N SingleStat__icon--UargA";
export { _1 as "amt", _2 as "check", _3 as "checkAmt", _4 as "checkIcon", _5 as "comet", _6 as "cometAmt", _7 as "cometIcon", _8 as "disabled", _9 as "galaxy", _a as "galaxyAmt", _b as "galaxyIcon", _c as "gray", _d as "icon", _e as "jigsaw", _f as "jigsawAmt", _10 as "jigsawIcon", _11 as "main", _12 as "moon", _13 as "moonAmt", _14 as "moonIcon", _15 as "office", _16 as "planet", _17 as "planetAmt", _18 as "planetIcon", _19 as "star", _1a as "starAmt", _1b as "starIcon", _1c as "student", _1d as "studentAmt", _1e as "studentIcon", _1f as "time", _20 as "timeAmt", _21 as "timeIcon", _22 as "trophy", _23 as "trophyAmt", _24 as "trophyIcon", _25 as "xp", _26 as "xpAmt", _27 as "xpIcon" }
